<template>
  <div class="applyNoatr">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
       <p class="notarization-desc-titile">
            （公证书仅限用于民事诉讼或仲裁）
          </p>
        <div class="notarization-title">
         
          <h3> 您正在将
            <span v-text="documentsNum"></span> 个证据文件统一申请公证
          </h3>
        </div>
      <el-form-item label="申请公证名称：" prop="name">
        <el-input v-model="ruleForm.name" placeholder="请输入要公证合同名称"></el-input>
      </el-form-item>
      <el-form-item label="包含证据文件："><el-input :disabled="true" v-model="documentsNum"></el-input></el-form-item>
      <!-- <el-form-item label="公证处所在地：" prop="notarization">
        <el-select v-model="ruleForm.notarization" placeholder="请选择" @change="linkageFn" >
           <el-option v-for="(item,index) in NotaryUser" :key="index" :label="item.province" :value="item.notaryCode"></el-option>
         
        </el-select>
      </el-form-item>
      <el-form-item label="公证处：" prop="location">
        <el-select v-model="ruleForm.location" placeholder="请选择">
          <el-option v-for="item in listData" :key="item.name" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="领取人：" prop="receiptor">
        <el-select v-model="ruleForm.receiptor" placeholder="请选择">
          <el-option label="本人领取" value="1"></el-option>
          <el-option label="其他自然人领取" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="公证员：" prop="notaryPeople">
        <el-select v-model="ruleForm.notaryPeople" placeholder="请选择">
          <el-option v-for="item in OfficeUserList" :key="item.name" :label="item.name" :value="item.id"></el-option>
          <el-option label="系统自动分配" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注：" prop="marker" class="marker_w">
        <el-input v-model="ruleForm.marker"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="cancelFn">取消</el-button>
        <el-button @click="resetForm('ruleForm')" style="display:none">重置</el-button>
        <el-button type="primary" :disabled="isSubmitIng" @click="submitForm('ruleForm')">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import BaseApi from "@lib/baseApi.js";
export default {
  data() {
    var marker = (rule, value, callback) => {
      if (value.length > 31) {
        callback(new Error("长度不超过30个字符"));
      } else {
        callback();
      }
    };
    return {
      isSubmitIng: false,
      notClick: true,
      listData: [],
      NotaryUser:[],
      id: [],
      type: 1,
      num: 0,
      documentsNum:1,
      ruleForm: {
        name: "",
        // notarization: "",
        notaryPeople:"",
        receiptor: "",
        // location: "",
        marker: ""
      },
      OfficeUserList:[],//公证员
      rules: {
        name: [
          { required: true, message: "请输入要公证合同名称", trigger: "blur" }
        ],
        marker: [
          { required: false, message: "请输入备注", trigger: "blur" },
          { validator: marker, trigger: "blur" }
        ],
        notarization: [
          { required: true, message: "请选择公证处", trigger: "blur" }
        ],
        receiptor: [
          { required: true, message: "请选择领取人", trigger: "blur" }
        ],
        notaryPeople:[
          { required: true, message: "请选择公证员", trigger: "blur" }
        ],
        location: [
          { required: true, message: "请选择公证所在地", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    init (){
         BaseApi.createRpcToken('/Judiciary/getNotaryUser').then((data) => {
          
          this.NotaryUser = data.datas.lits;
          // this.NotaryUser.unshift({notaryCode: "0", province: "请选择"})
        },data=>{})
        .catch((e)=>{
          errorLog(e);
        })
      },
      checkNameHave(){

      },
      getNotaryOfficeUser(){
        let  params= {
              notaryOfficeId:1
            }
         BaseApi.createRpcToken("/notary/user/getNotaryUserList", params, "post")
          .then((res) => {
            if(res.datas.code==200){
              this.OfficeUserList=res.data.datas.notaryUserList;
            }
          })
          .catch((error) => {
            // //console.log(error);
          })
      },
    submitForm(formName) {
      this.isSubmitIng = true;
       var newLocation={};
      this.$refs[formName].validate(valid => {
        if (valid) {
          if(this.NotaryUser && this.listData){
              // this.ruleForm.notarization=this.NotaryUser.filter(item=>item.notaryCode==this.ruleForm.notarization)[0]
              // this.ruleForm.notarization= this.listData.filter(item=>item.code== this.ruleForm.notarization)[0]
              //  if (this.ruleForm.notarization == 110000) {
              //   this.ruleForm.notarization = "北京";
              // } else if(this.ruleForm.notarization == 130000) {
              //   this.ruleForm.notarization = "河北";
              // }else if(this.ruleForm.notarization == 330000){
              //   this.ruleForm.notarization = "浙江";
              // }else{
              //   this.ruleForm.notarization = "北京";
              // }
              // this.ruleForm.notarization= 
             newLocation=this.listData.filter(item=>item.id== this.ruleForm.location)[0] 
           }
               
          var params = {
            name: this.ruleForm.name,
            packageCount: 1,
            // notaryId: this.ruleForm.location,
            notarial: "",
            // location: newLocation.addres,
            // location: this.ruleForm.notarization.province,
            recipientType: this.ruleForm.receiptor,
            contractIds: this.id,
            remarks: this.ruleForm.marker,
            type: this.type
          };
          for (var i = 0; i < this.listData.length; i++) {
            if (this.listData[i].id == params.notaryId) {
              params.notarial = this.listData[i].name;
            }
          }
          BaseApi.createRpcToken("/Judiciary/saveNotarization", params, "post")
            .then(
              data => {
                this.notClick = false;
                setTimeout(() => {
                  this.notClick = true;
                });
                if (data.datas.code == "3706") {
                  this.$emit("closeDialog", false);
                  this.$emit("hintMessage", true);
                  this.resetForm(formName);
                  setTimeout(() => {
                    this.$emit("hintMessage", false);
                    this.$emit("applyNotar", true);
                    this.isSubmitIng = false;
                  }, 2000);
                  return;
                }
                if (data.datas.code == 5001) {
                  this.isSubmitIng = false;
                  this.$message.error("系统繁忙");
                  return;
                }
                if (data.datas.success == true) {
                  this.$emit("closeDialog", false);
                  this.$emit("successMessageFn", true);
                  setTimeout(() => {
                    this.$emit("closeHints", true);
                    this.$router.replace({
                      path: "/personal/serviceHome/writeProcedure"
                    });
                    this.isSubmitIng = false;
                  });
                  localStorage.removeItem("xinxi");
                  sessionStorage.setItem("xinxi", JSON.stringify(data.datas));
                } else {
                  this.isSubmitIng = false;
                  this.$message.error("申请公证失败！");
                  this.resetForm(formName);
                  this.num = 0;
                  this.$emit("hintMessage", false);
                }
              },
              data => {
                this.isSubmitIng = false;
              }
            )
            .catch(function(e) {
              errorLog(e);
            });
        } else {
          this.isSubmitIng = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    cancelFn() {
      this.$emit("closeDialog", false);
    },
    linkageFn() {
      var params = {
        notaryCode: this.ruleForm.notarization
      };
      BaseApi.createRpcToken("/Judiciary/findNotarization", params, "get")
        .then(
          data => {
            this.listData = data.datas.lits;
            this.ruleForm.location = data.datas.lits[0].id;
          },
          data => {
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    setData(arr) {
      this.id = arr;
      this.num = this.id.length;
    }
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let userArr=[...[userInfo.person],...userInfo.enterpriseList];
    let curInfo=userArr.filter(item=>item.userId==userInfo.currentUserId)[0];
    this.type=curInfo.realNameType
    this.init();
  }
};
</script>
<style lang="scss">
.applyNoatr {
  .el-form {
    // padding:0px 30px;
    box-sizing: border-box;
    display: table;
    .el-form-item {
      float: left;
      width: calc(95% / 2);
      .el-form-item__label {
        font-size: 14px;
        color: #1E1E1E;
        line-height: 30px;
        padding: 0;
        width: 100px !important;
      }
      .el-form-item__label:before {
        content: "" !important;
        margin: 0 !important;
      }
      .el-form-item__content {
        line-height: 30px;
        margin-left: 100px !important;
        .el-input {
          .el-input__inner {
            width: 168px;
            height: 30px;
            border-radius: 0;
            line-height: 30x;
            padding-left: 10px;
          }
          .el-input__icon {
            line-height: 30px;
          }
          .el-input__inner::placeholder{
            font-size: 14px;
          }
        }
      }
      .el-button {
        width: 100px;
        height: 30px;
        border: 1px solid #db4437;
        line-height: 30px;
        padding: 0;
        border-radius: 0;
        background-color: #fff;
        font-size: 14px;
        color: #646464;
        margin-left: 67px;
      }
      .el-button.is-disabled,
      .el-button.is-disabled:focus,
      .el-button.is-disabled:hover {
        cursor: not-allowed;
        background-image: none;
        background: rgb(220, 220, 220);
        border-color: #ebeef5;
      }
    }
    .marker_w{
      width: 91%;
      .el-input__inner{
        width: 92% !important;
      }
    }
    .el-form-item:nth-child(2n-1) {
      margin-right: 10px;
      margin-left: 20px;
    }
    // .el-form-item:nth-child(6) {
    //   width: 100%;
    //   .el-input__inner {
    //     width: 100% !important;
    //   }
    // }
    .el-form-item:nth-child(2) {
      padding-left: 0px;
      box-sizing: border-box;
    }
    .el-form-item:last-child {
      width: 100% !important;
      .el-button--primary {
        color: #db4437;
        margin-right: 100px;
        margin-left: 90px;
      }
      .el-button--primary:hover {
        color: #fff;
        border-color: #a5303d;
        background-color: #a5303d;
      }
      .el-button:first-child {
        border: 1px solid #c8c8c8;
      }
      .el-button:first-child:hover {
        color: #db4437;
        border-color: #db4437;
      }
    }
  }
  .notarization-desc-titile{
    width: 100%;
    text-align: center;
    height: 40px;
    line-height: 40px;
    background: #F6E0E2;
    color:#C76169;
    font-size: 14px;
  }
  .notarization-title {
    width: 100%;
    height: 46px;
    background-color: #F6F6F6;
    text-align: center;
    line-height: 46px;
    color: #464646;
    margin-bottom: 20px;
    h3{
      font-weight: normal;
      font-size: 14px;
    }
  }
}
</style>

